export default __webpack_public_path__ + "static/media/mehul-rastogi.fd965652.webp";